<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9 1C9 0.5 8.55228 0 8 0C7.44772 0 7 0.5 7 1V6L4.5329 3.43802C4.23056 3.13567 3.74037 3.13567 3.43803 3.43802C3.13569 3.74036 3.13569 4.23055 3.43803 4.53289L6 7H1C0.5 7 0 7.47818 0 8C0 8.55078 0.5 9 1 9H6L3.43803 11.4671C3.13569 11.7695 3.13569 12.2596 3.43803 12.562C3.74037 12.8643 4.23057 12.8643 4.53291 12.562L7 10V15C7 15.5 7.5 16 8 16C8.5 16 9 15.5 9 15V10L11.4671 12.562C11.7695 12.8643 12.2596 12.8643 12.562 12.562C12.8643 12.2596 12.8643 11.7694 12.562 11.4671L10 9H15C15.5 9 16 8.5 16 8C16 7.5 15.5 7 15 7H10L12.562 4.53291C12.8643 4.23056 12.8643 3.74037 12.562 3.43803C12.2597 3.13569 11.7695 3.13569 11.4671 3.43803L9 6V1Z"
    fill="currentColor"
  />
</svg>
